import * as Yup from 'yup';
import { Formik } from 'formik';
import React, { Fragment } from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { JobPositionDropdown } from 'components/layout/form-fields/inputs/JobPositionDropdown';
import { jobApplicationStore } from './JobApplicationStore';
import { notificationStore } from 'components/layout/notifications/NotificationStore';

const ValidationSchema = Yup.object().shape({
	job: Yup.object().label('Job')
});

export class AddJobModal extends ModalComponent {
	getInitialValues() {
		return {
			job: null
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.create(values);
				}}>
				{formikBag => this.renderModalContainer(formikBag, 'AddJobModal')}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<Fragment>
				<div className="columns">
					<div className="column is-full">
						<div className="field has-text-left">
							<label className="subtitle is-7">Job Position</label>
							<div className="control">
								<JobPositionDropdown
									onValueChange={item => {
										formikBag.setFieldValue('job', item);
									}}
									value={formikBag.values.job}
									showOnlyOpenJobs
								/>
							</div>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}

	async create(values) {
		try {
			const result = await jobApplicationStore.addApplication({
				jobId: values.job.id,
				applicantId: this.props.applicantId
			});

			if (result.status === 'success') {
				this.resultNotification(
					result,
					'Candidate',
					'Add',
					'Assign to an Open Job',
					'The candidate has been successfully assigned to the job.'
				);
			} else {
				const errorMessage =
					result.message || 'An error has occurred. Please try again.';
				notificationStore.pushNotification({
					type: notificationStore.ERROR_NOTIFICATION,
					title: 'Assign to an Open Job',
					message: errorMessage
				});
				this.saving(false);
			}
		} catch (error) {
			notificationStore.pushNotification({
				type: notificationStore.ERROR_NOTIFICATION,
				title: 'Assign to an Open Job',
				message: 'An error has occurred. Please try again.'
			});
			this.saving(false);
		}
	}
}
